import { toLower, flow } from 'lodash'

export enum RaceType {
  MOUNTAIN_BIKE = 'mountainbike',
  TRIATHLON = 'triathlon',
  LAKE = 'lake',
  CYCLING = 'cycling',
  OBSTACLE = 'obstacle',
  RUNNING = 'running',
  STAIRS = 'stairs',
  SWIM = 'swim',
  UNDEFINED = 'undefined'
}

export enum IntervalRaceType {
  CYCLING = 'cycling',
  RUNNING = 'running',
  SWIM = 'swimming',
  TRANSITION = 'transition',
  UNDEFINED = 'undefined'
}

export enum RaceTimeType {
  CHIP = 'CHIP',
  GUN = 'GUN',
  UNDEFINED = 'UNDEFINED'
}

export function cleanInputs(rawRaceType: string) {
  return rawRaceType ? rawRaceType.replace(/[^0-9a-zA-Z]/g, '') : undefined
}

export function emptyToUndefined(str: string) {
  return str === '' ? undefined : str
}

const raceTimeTypeMap = {
  ['chip']: () => RaceTimeType.CHIP,
  ['gun']: () => RaceTimeType.GUN
}

const raceTypeMap = {
  ['adventureracing']: () => RaceType.MOUNTAIN_BIKE,
  ['aquabike']: () => RaceType.TRIATHLON,
  ['aquathlon']: () => RaceType.TRIATHLON,
  ['canoekayak']: () => RaceType.LAKE,
  ['criterium']: () => RaceType.CYCLING,
  ['cycling']: () => RaceType.CYCLING,
  ['cyclocross']: () => RaceType.CYCLING,
  ['duathlon']: () => RaceType.TRIATHLON,
  ['funrun']: () => RaceType.RUNNING,
  ['mountainbiking']: () => RaceType.MOUNTAIN_BIKE,
  ['mountainclimb']: () => RaceType.MOUNTAIN_BIKE,
  ['obstacle']: () => RaceType.OBSTACLE,
  ['orienteering']: () => RaceType.RUNNING,
  ['paddletriathlon']: () => RaceType.LAKE,
  ['paddleboarding']: () => RaceType.LAKE,
  ['racewalk']: () => RaceType.RUNNING,
  ['racewalking']: () => RaceType.RUNNING,
  ['running']: () => RaceType.RUNNING,
  ['run']: () => RaceType.RUNNING,
  ['skicrosscountry']: () => RaceType.RUNNING,
  ['snowshoerunning']: () => RaceType.RUNNING,
  ['stairclimb']: () => RaceType.STAIRS,
  ['swimming']: () => RaceType.SWIM,
  ['trailrunning']: () => RaceType.RUNNING,
  ['trailrunninghiking']: () => RaceType.RUNNING,
  ['triathlonmultisport']: () => RaceType.TRIATHLON
}

const intervalRaceTypeMap = {
  ['triathlon']: () => IntervalRaceType.UNDEFINED,
  ['moutainbiking']: () => IntervalRaceType.CYCLING,
  ['mountainbike']: () => IntervalRaceType.CYCLING,
  ['cycling']: () => IntervalRaceType.CYCLING,
  ['cycle']: () => IntervalRaceType.CYCLING,
  ['bike']: () => IntervalRaceType.CYCLING,
  ['swimming']: () => IntervalRaceType.SWIM,
  ['swim']: () => IntervalRaceType.SWIM,
  ['multisport']: () => IntervalRaceType.RUNNING,
  ['obstacle']: () => IntervalRaceType.RUNNING,
  ['transition']: () => IntervalRaceType.TRANSITION,
  ['running']: () => IntervalRaceType.RUNNING,
  ['run']: () => IntervalRaceType.RUNNING,
  ['undefined']: () => IntervalRaceType.UNDEFINED
}

export function normalizeRaceType(possibleRaceType: string): RaceType {
  const mapper = raceTypeMap[
      flow(
        cleanInputs,
        toLower,
        emptyToUndefined
      )(possibleRaceType)
    ]
  return (mapper) ? mapper() : RaceType.UNDEFINED
}

export function normalizeRaceTimeType(possibleRaceTimeType: string): RaceTimeType {
  const mapper = raceTimeTypeMap[
      flow(
        cleanInputs,
        toLower,
        emptyToUndefined
      )(possibleRaceTimeType)
    ]
  return (mapper) ? mapper() : RaceTimeType.UNDEFINED
}

export function normalizeIntervalRaceType(possibleRaceType: string): IntervalRaceType {
  const mapper = intervalRaceTypeMap[
      flow(
        cleanInputs,
        toLower,
        emptyToUndefined
      )(possibleRaceType)
    ]
  return (mapper) ? mapper() : IntervalRaceType.UNDEFINED
}